import Vue from "vue";
import "babel-polyfill";
import VueRouter from "vue-router";
import routes from "./router";
import App from "./views/app.vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from "./store/store";
//
import "swiper/dist/css/swiper.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "leaflet/dist/leaflet.css";

import "@/assets/style/reset.scss";
// 全局注册组件
import "./config/reg.js";
import { routerMode, imgBaseUrl, baseUrl } from "./config/url";
import { toThumbsimg } from "./config/toThumbsimg.js";
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.prototype.$toThumbsimg = toThumbsimg;
Vue.prototype.$imgBaseUrl = imgBaseUrl;
Vue.prototype.$baseUrl = baseUrl;

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
const router = new VueRouter({
    routes,
    mode: routerMode,
    base: "/pc/",
    strict: process.env.NODE_ENV !== "production",
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            if (from.meta.keepAlive) {
                from.meta.savedPosition = document.body.scrollTop;
            }
            return {
                x: 0,
                y: to.meta.savedPosition || 0
            };
        }
    }
});
router.beforeEach((to, from, next) => {
    if (to.query.token) {
        store.commit("SET_TOKEN", to.query.token);
        store.commit("SET_IS_PERSONAL", to.query.isPersonal === "1");
        store.commit("SET_USER_ID", to.query.userId);
        // Local.set('token', to.query.token)
        // Local.set('isPersonal', to.query.isPersonal === '1')
    }
    if (!store.state.ssoApiBase.startsWith("http")) {
        store
            .dispatch("domainInfo")
            .then(() => {
                next(vm => {
                    createIframeHandleToken(
                        "GET",
                        this.$store.state.ssoLoginJumpUrl
                    );
                });
            })
            .catch(() => {
                next();
            });
    } else {
        next();
    }
});
/**
 * 全局路由钩子
 */
// new Vue({
//   el: '#app',
//   components: {
//     App
//   },
//   router,
//   store
// })
new Vue({
    el: "#app",
    router,
    components: { App },
    template: "<App/>",
    store
});

window.addEventListener(
    "message",
    function(evt) {
        if (evt.origin !== location.origin) {
            var options = JSON.parse(evt.data);
            console.log("userId===============" + options.userId);
            console.log("token===============" + options.token);
            document.querySelector("iframe").remove();
            // 登陆
            if (options.inOrOut === "0") {
                store.commit("SET_TOKEN", options.token);
                store.commit("SET_IS_PERSONAL", options.userType === "1");
                store.commit("SET_USER_ID", options.userId);
            } else if (options.inOrOut === "1") {
                // 登出
                store.commit("SET_TOKEN", "");
                store.commit("SET_IS_PERSONAL", "");
                router.replace("/zh-CN/index");
            }
        }
    },
    false
);
/**
 * 浏览器刷新时，导致vue中保存的vuex清空
 * 保存面包屑数据
 */
// 刷新保存状态
if (sessionStorage.getItem("store") && !store.state.token) {
    store.replaceState(
        Object.assign(
            {},
            store.state,
            JSON.parse(sessionStorage.getItem("store"))
        )
    );
    sessionStorage.removeItem("store");
}
// 监听，在页面刷新时将vuex里的信息保存到sessionStorage里
window.addEventListener("beforeunload", () => {
    sessionStorage.setItem("store", JSON.stringify(store.state));
});



// WEBPACK FOOTER //
// ./src/main.js